import { Box, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import QuoteForm from "../QuoteForm/QuoteForm";
import { useNavigate } from "react-router-dom";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";

const NewQuotePage = () => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const saveNewQuote = async (quote) => {
    try {
      setLoading(true);

      let response = await ezorder.post(
        `/admin/orders`,
        { ...quote },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log(response.data.order);
      if (response.status == 200 || response.status === 201) {
        openSnackMessage("success", "Quote Saved!");
        navigate(`/quotes/${response.data.order.id}`);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" textAlign="center">
        New Quote
      </Typography>
      <QuoteForm
        orderId={null}
        onSave={(quote) => {
          saveNewQuote(quote);
        }}
        saving={loading}
        saveButtonTitle="Save Quote"
      />
    </Box>
  );
};

export default NewQuotePage;
